
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import randomId from 'random-id'
import classnames from 'classnames'
import { format } from 'url'
import './Environment.css'

/**
 * Environments.
 */

const environments = [
  { name: 'development', protocol: 'http:', host: 'localhost:8000' },
  { name: 'staging', host: 'segment.build' },
  { name: 'canary', host: 'canary.segment.com' },
  { name: 'production', host: 'production.segment.com' }
]

class Environment extends Component {
  constructor () {
    super()

    this.state = {
      popupId: randomId(),
      isOpen: false
    }
  }

  render () {
    const { version } = this.props
    const environment = this.props.environment.toLowerCase()
    const classNames = {
      Environment: true,
      'Environment--is-open': this.state.isOpen,
      [`Environment--${environment}`]: true
    }

    return (
      <div className={classnames(classNames)} ref={ref => (this.el = ref)}>
        <button
          type='button'
          className='Environment-button'
          title={environment}
          aria-controls={this.state.popupId}
          aria-expanded={this.state.isOpen + ''}
          aria-haspopup='true'
          onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
          <span className='Environment-a11yhide'>
              Toggle environment tools
            </span>
        </button>

        <div
          className='Environment-popup'
          id={this.state.popupId}
          aria-hidden={!this.state.isOpen + ''}>
          <div>
            <label>
                Environment:
                <select value={environment} onChange={navigate}>
                  {environments.map(({ name }, index) =>
                    <option value={name} key={`__environment_${index}`}>
                      {name}
                    </option>
                  )}
                </select>
            </label>
          </div>
          <div>
              Version: {version}
          </div>
        </div>
      </div>
    )

    function navigate (e) {
      const { protocol = 'https:', host } = environments.find(({ name }) => {
        return name === e.target.value
      })

      const url = format({
        ...window.location,
        protocol,
        host
      })

      window.location = url
    }
  }

  componentDidMount () {
    // Hide the popup when anywhere else on the page is clicked
    document.body.addEventListener('click', (e) => {
      if (this.el.contains(e.target)) {
        return
      }

      this.setState({ isOpen: false })
    })
  }
}

Environment.propTypes = {
  environment: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired
}

Environment.displayName = 'Environment'

export default Environment



// WEBPACK FOOTER //
// ./ui/Environment.js